
export default {
  props: {
    options: {type: Array, required: true},
    disabled: {type: Boolean, required: true},
    answer: {type: Object, default: undefined},
    skip: {type: Object, default: undefined},
    skipAll: {type: Object, default: undefined},
  },
  emits: ['prompt'],
  data() {
    return {
      // TODO: In onboarding answer is not saved, so we need 
      // to use selected_idx to track the current selection
      // Should be removed after onboarding is refactored to 
      // save answers in the history
      selected_idx: -1
    }
  },
  computed: {
    selected() {
      if (this.answer) {
        return this.options.findIndex(item => item.chat_query.text === this.answer.text)
      }
      return this.selected_idx
    }
  },
  methods: {
    optionDisabled(idx){
      if (idx === this.selected) return false
      return this.disabled || this.selected !== -1
    },
    onAccept(idx){
      this.selected_idx = idx
      const selection = this.options[idx]
      this.$emit('prompt', {
        title: selection.title,
        ...selection.chat_query
      })
    },
    onSkip(){
      this.$emit('prompt', this.skip.chat_query || {})
    },
    onSkipAll(){
      this.$emit('prompt', this.skipAll.chat_query || {})
    }
  }
}
